import Vehicle from '@/models/vehicle'

export default class VehicleList {
  public items: Vehicle[]

  constructor (vehicles: []) {
    this.items = []
    // Add vehicles to list
    vehicles.forEach(vehicle => {
      this.items.push(new Vehicle(vehicle))
    })
  }
}
